import { message } from 'ant-design-vue'
import axios, { AxiosInstance, AxiosResponse } from 'axios'
import defaultSetting from '../../config/defaultSetting'
import { useModule } from '@/hooks'
import { useUserStore, useAppRouter } from '@/store'
import router from '@/router'
console.log('process.env:', process.env)

export const instance = axios.create({
  baseURL: process.env.NODE_ENV === 'development' ? '/api' : 'https://www.jy-health.pro/api',
  // baseURL: '/api',˚
  timeout: 100000
})

/**
 * 该函数捕获一个错误并返回一个被拒绝的承诺。
 * @param {any} error - `error` 参数是 `any` 类型，这意味着它可以是任何数据类型。它用作 `catchErr` 函数的输入参数。
 * @returns `catchErr` 函数返回一个被拒绝的 Promise，并传递了 `error` 参数作为拒绝的原因。
 */

const catchErr = (response: AxiosResponse) => {
  const { data } = response
  if (data.code === 500) {
    message.error(data.msg)
  } else if (data.code === 400) {
    message.error(data.msg)
  }
}

/**
 * 登录失效后重定向地址
 */
const redirectUrl = () => {
  window.open(defaultSetting.logout + `?redirectUrl=${useModule().path}`)
}

instance.interceptors.request.use(config => {
  console.log('config:', config.headers.platform)
  config.headers.Authorization = useUserStore().token
  if (!config.headers.platform) {
    if (['/web/user/login', '/web/user/currUser'].includes(config.url as string)) {
      config.headers.platform = 'home'
    } else {
      config.headers.platform = useAppRouter().router.navbar.selectPath === '/home' ? 'home' : 'health'
    }
  }

  // platform = home | health

  return config
}, function (error) {
  return Promise.reject(error)
})

instance.interceptors.response.use(function (response) {
  catchErr(response)
  console.log('response:', response)

  if (response.data.code === 401) {
    message.error('登录失效, 请重新登录')
    window.localStorage.removeItem('userInfo')
    router.replace({ path: '/login' })
    // useUserStore().autoLogout()
  }
  return response.data
}, error => Promise.reject(error))

export const setBaseUrl = (baseURL: string) => instance.defaults.baseURL = baseURL

export default function request <T> (config: any) {
  return instance.request<AxiosInstance, T>(config)
}
